var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoc = function SvgDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.466 9.336V0H.164v18.5a3.002 3.002 0 002.999 3H17a3.002 3.002 0 003-3V9.337h-4.535zm-12.303 10.7A1.536 1.536 0 011.628 18.5V1.5h12.374v17c0 .561.155 1.086.423 1.536H3.163zM18.536 18.5c0 .846-.689 1.535-1.535 1.535a1.536 1.536 0 01-1.535-1.535V10.8h3.07v7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.247 11.534h1.465V13h-1.465v-1.465zM3.755 11.534h6.028V13H3.755v-1.465zM11.247 14.463h1.465v1.464h-1.465v-1.464zM3.755 14.463h6.028v1.464H3.755v-1.464zM11.247 17.32h1.465v1.465h-1.465V17.32zM3.755 17.32h6.028v1.465H3.755V17.32zM4.907 8.009l3.397-4.53 1.172.878-3.398 4.53-1.171-.878zM4.616 3.556h1.465V5.02H4.616V3.556zM8.386 7.178H9.85v1.464H8.386V7.178z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc.3ae6559e.svg";
export { ForwardRef as ReactComponent };